import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { companiesApi } from '@/features/brands/api';
import { queryKeys } from '@/lib/api/queryKeys';
import { AgencyHome } from '@/features/dashboard/DashboardPage';
import { Skeleton } from '@/components/ui/Skeleton';

/**
 * Agency profile — operational view of an agency workspace.
 * Reuses the AgencyHome surface (brand portfolio · live now · quick actions),
 * scoped to the agency in the URL. Reached from the workspace pill in TopBar.
 */
export function AgencyProfilePage() {
  const { id } = useParams<{ id: string }>();
  const companyId = Number(id);
  const q = useQuery({
    queryKey: queryKeys.companies.detail(companyId),
    queryFn: () => companiesApi.get(companyId),
    enabled: Number.isFinite(companyId),
  });

  if (q.isLoading || !q.data) {
    return (
      <div className="page">
        <Skeleton className="mb-4 h-9 w-72 rounded" />
        <Skeleton className="h-40 w-full rounded-xl" />
      </div>
    );
  }
  return <AgencyHome company={q.data} />;
}
